/** サンプル庫内位置（保管庫・引き出し・ケース）の表示用パーツ（一覧・帳票・使用履歴で共用） */

import { formatEntityDisplayName } from './softBreakIdentifier';

export type SampleLocationBits = {
  storageRoom?: string | null;
  caseName?: string | null;
  drawerNumber?: number | null;
};

export type SampleLocationFactRole = 'type' | 'room' | 'drawer' | 'case';

export type SampleLocationFact = {
  role: SampleLocationFactRole;
  text: string;
};

/** 保管パス断片を #引き出し · ケース の順で組み立て（ハッシュ＝引き出し） */
export function buildSampleLocationFacts(
  bits: SampleLocationBits | null | undefined,
  typeDisp?: string | null
): SampleLocationFact[] {
  const h = bits ?? {};
  const room = formatEntityDisplayName(String(h.storageRoom ?? '').trim());
  const caseName = formatEntityDisplayName(String(h.caseName ?? '').trim());
  const facts: SampleLocationFact[] = [];
  if (typeDisp && typeDisp !== '-') {
    facts.push({ role: 'type', text: typeDisp });
  }
  if (room) {
    facts.push({ role: 'room', text: room });
  }
  if (h.drawerNumber != null) {
    facts.push({ role: 'drawer', text: `#${h.drawerNumber}` });
  }
  if (caseName) {
    facts.push({ role: 'case', text: caseName });
  }
  return facts;
}

export function joinSampleLocationFacts(
  facts: SampleLocationFact[],
  sep = ' · '
): string {
  return facts.map((f) => f.text).join(sep);
}

/** 帳票モバイル用: 役割付き span（CSS でタイプ強調・保管庫省略） */
export function formatReportMobileFactsHtml(
  escapeHtml: (s: string) => string,
  bits: SampleLocationBits | null | undefined,
  typeDisp?: string | null
): string {
  const facts = buildSampleLocationFacts(bits, typeDisp);
  if (facts.length === 0) return '';
  const parts = facts.flatMap((fact, i) => {
    const span = `<span class="report-fact report-fact--${fact.role}">${escapeHtml(fact.text)}</span>`;
    if (i === 0) return [span];
    // 前後スペース付き ·（狭幅で色が薄いと「病原体 Freezer」と潰れて見える）
    return [`<span class="report-fact-sep" aria-hidden="true"> · </span>`, span];
  });
  /* 名前行との textContent 連結で「…サンプル病原体」にならないよう先頭にも · */
  const leadSep =
    '<span class="report-fact-sep visually-hidden" aria-hidden="true"> · </span>';
  /* button 内に置けるよう span（div は無効） */
  return `<span class="report-mobile-facts">${leadSep}${parts.join('')}</span>`;
}
